import { Injectable } from '@angular/core';
import { CartRemoveEntrySuccessEvent } from '@spartacus/cart/base/root';
import { createFrom, EventService } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { GtmGgCartRemoveEntrySuccessEvent } from './gtm-gg-cart-remove-entry-success-event';

@Injectable({
  providedIn: 'root',
})
export class GtmGgCartRemoveEntrySuccessEventBuilder {
  constructor(private eventService: EventService) {
    const gtmGgCartRemoveEntrySuccessEventSource = this.eventService.get(CartRemoveEntrySuccessEvent).pipe(
      map((successfullyRemovedEntry) =>
        createFrom(GtmGgCartRemoveEntrySuccessEvent, {
          event: 'remove-from-cart',
          productId: successfullyRemovedEntry.entry.product?.code ? successfullyRemovedEntry.entry.product.code : '',
          ecommerce: {
            currencyCode: successfullyRemovedEntry.entry.product?.price?.currencyIso
              ? successfullyRemovedEntry.entry.product.price.currencyIso
              : '',
            remove: {
              products: [
                {
                  name: successfullyRemovedEntry.entry.product?.name ? successfullyRemovedEntry.entry.product.name : '',
                  id: successfullyRemovedEntry.entry.product?.code ? successfullyRemovedEntry.entry.product.code : '',
                  price: successfullyRemovedEntry.entry.product?.price?.value
                    ? successfullyRemovedEntry.entry.product.price.value
                    : '',
                  quantity: successfullyRemovedEntry.entry.quantity ? successfullyRemovedEntry.entry.quantity : '',
                },
              ],
            },
          },
        })
      )
    );

    eventService.register(GtmGgCartRemoveEntrySuccessEvent, gtmGgCartRemoveEntrySuccessEventSource);
  }
}
